import { r as registerInstance, h, H as Host } from './index-8f7fb048.js';

const marketActivityIndicatorCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}svg{position:static;flex:none;fill:currentColor;animation:rotation 1s infinite linear}@keyframes rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}";

const MarketActivityIndicator = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.size = 'large';
  }
  render() {
    let height, width;
    switch (this.size) {
      case 'large':
        width = 48;
        height = 48;
        break;
      case 'small':
        width = 24;
        height = 24;
        break;
      default:
        width = this.size;
        height = this.size;
    }
    return (h(Host, { class: "market-activity-indicator" }, h("svg", { width: width, height: height, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M42.6667 24C42.6667 13.6907 34.3093 5.33333 24 5.33333V0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24H5.33333C5.33333 34.3093 13.6907 42.6667 24 42.6667C34.3093 42.6667 42.6667 34.3093 42.6667 24Z", "fill-opacity": "0.9" }))));
  }
};
MarketActivityIndicator.style = marketActivityIndicatorCss;

export { MarketActivityIndicator as market_activity_indicator };
